import PropTypes from 'prop-types';
import AddressProp from '../../../commonComponents/forms/Address/AddressProp';
import OrderHistoryProp from './orderHistoryProp';

const latestOrderPropType = {
  _id: PropTypes.string,
  number: PropTypes.number,
  status: PropTypes.string,
};
const propType = {
  billingAddress: PropTypes.shape(AddressProp.propType),
  createdAt: PropTypes.number,
  currency: PropTypes.string,
  deleted: PropTypes.bool,
  discount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  discountTotal: PropTypes.number,
  frequency: PropTypes.string,
  isActive: PropTypes.boolean,
  history: PropTypes.arrayOf(PropTypes.shape(OrderHistoryProp.propType)),
  latestOrder: PropTypes.shape(latestOrderPropType),
  nextPaymentDate: PropTypes.number,
  owner: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  paymentId: PropTypes.string,
  products: PropTypes.array,
  shipping: PropTypes.string,
  shippingAddress: PropTypes.shape(AddressProp.propType),
  shippingTotal: PropTypes.number,
  status: PropTypes.string,
  subtotal: PropTypes.number,
  tax: PropTypes.number,
  total: PropTypes.number,
  updatedAt: PropTypes.number,
  vat: PropTypes.number,
  _id: PropTypes.string,
  paymentMethodType: PropTypes.string,
  subscriptionStartDate: PropTypes.number,
  subscriptionEndDate: PropTypes.number,
  productParent: PropTypes.object,
};

export default { propType };
